import { z } from 'zod';

import { chatMessageIdSchema } from './chat-ids';
import { structuredResponseEventSchema } from './structured-tools';

export const assistantTextEntrySchema = z.object({
    text: z.string(),
    type: z.literal('text'),
});

export type AssistantTextEntry = z.infer<typeof assistantTextEntrySchema>;

export const assistantEventEntrySchema = z.object({
    envelope: structuredResponseEventSchema,
    type: z.literal('event'),
});

export type AssistantEventEntry = z.infer<typeof assistantEventEntrySchema>;

export const assistantMessageEntrySchema = z.discriminatedUnion('type', [
    assistantTextEntrySchema,
    assistantEventEntrySchema,
]);

export type AssistantMessageEntry = z.infer<typeof assistantMessageEntrySchema>;

export const assistantMessageStatusSchema = z.enum(['complete', 'error', 'pending']);

export type AssistantMessageStatus = z.infer<typeof assistantMessageStatusSchema>;

export const agentChatMessageSchema = z.object({
    createdAt: z.string(),
    entries: z.array(assistantMessageEntrySchema).optional(),
    id: chatMessageIdSchema,
    role: z.enum(['user', 'assistant']),
    status: assistantMessageStatusSchema.optional(),
    text: z.string().optional(),
});

export type AgentChatMessage = z.infer<typeof agentChatMessageSchema>;

export const agentChatMessagePageSchema = z.object({
    messages: z.array(agentChatMessageSchema),
    nextCursor: z.uuid().nullable(),
});

export type AgentChatMessagePage = z.infer<typeof agentChatMessagePageSchema>;
